<template>
  <div class="relative">
    <ul
      class="gap-x-2 gap-y-4 |gap-y-2"
      :class="[layout, { wrap: layout === 'flex' }]"
      :style="{
        gridTemplateColumns: layout === 'grid'
          ? `repeat(${Math.min(filter.options.length, 3)}, minmax(0, 1fr))`
          : undefined,
      }"
    >
      <li v-for="({ id, label }, i) in filter.options" :key="id + i">
        <base-toggle v-model="model" data-test-id="vf-size-filter" :value="id">
          <span
            class="h-10 flex grow center b text-center text-xs duration peer-focus-visible:outline-auto"
            :class="[
              brandClasses.base,
              model?.includes?.(id)
                ? brandClasses.selected
                : brandClasses.unselected,
            ]"
          >
            <span class="w-full select-none px-3" data-test-id="vf-size-picker-text">
              {{ label }}
            </span>
          </span>
        </base-toggle>
      </li>
    </ul>
    <div v-if="loading" class="absolute-0 bg-white op-50" />
  </div>
</template>

<script lang="ts" setup>
import type { SizeFilter } from '#types/filters'

const { layout = 'flex' } = defineProps<{
  filter: SizeFilter
  layout?: 'flex' | 'grid'
  loading?: boolean
}>()

const { brandClasses } = useAppConfig().components.filter.option.tileExpanded
const model = defineModel<string[]>()
</script>
